export const values = {
  black: "#0A0A0A",
  grey: "#A5A5A5",
  white: "#fff",
  activeBlue: "#1C76FC"
};
